<div class="mobile-header-wrapper justify-between flex mx-5">
    <a href="https://www.enterprisewireless.org/">
        <img
            class="max-w-[150px]"
            src="assets/images/EWA_Logo.jpg"
            alt="EWA Logo"
        />
    </a>
    <div class="flex items-center justify-end ml-auto">
        <div class="relative max-w-[140px]">
            <input
                matInput
                class="w-full pr-10 text-sm search-input"
                placeholder="Search"
            />
            <mat-icon class="absolute right-0 top-0 mt-2 mr-2 cursor-pointer"
                >search</mat-icon
            >
        </div>
        <div class="flex items-center">
            <app-header-dropdown [isMobile]="true"></app-header-dropdown>
        </div>
        <button
            mat-icon-button
            [matMenuTriggerFor]="mobileMenu"
            class="ml-2"
            aria-label="Navigation Menu"
        >
            <mat-icon>menu</mat-icon>
        </button>
    </div>

    <mat-menu
        #mobileMenu="matMenu"
        class="mobile-menu lg:hidden"
        [hasBackdrop]="false"
    >
        @for (headerLink of headerLinks; track headerLink) {
            <div class="flex">
                <a
                    href="https://www.google.com"
                    class="flex items-center flex-1 pl-3"
                >
                    {{ headerLink.text }}
                </a>
                <button
                    mat-menu-item
                    (click)="toggleDetails($event, headerLink.text)"
                    class="toggle-button"
                >
                    <mat-icon class="!m-0">{{
                        showDetails[headerLink.text]
                            ? 'keyboard_arrow_down'
                            : 'keyboard_arrow_right'
                    }}</mat-icon>
                </button>
            </div>

            @if (showDetails[headerLink.text]) {
                <div class="bg-neutral-200">
                    @for (childLink of headerLink.childLinks; track childLink) {
                        <a
                            mat-menu-item
                            href="{{ childLink.url }}"
                            class="!pl-6"
                            >{{ childLink.text }}</a
                        >
                    }
                </div>
            }
        }
    </mat-menu>
</div>
